
import { getFileUrlSuffix } from "@common/src/utils/common";
import { Component, Prop, Vue } from "vue-property-decorator";
import MP4 from "@/assets/img/Mp4@2x.png";
import Excel from "@/assets/img/Exel@2x.png";
import pdf from "@/assets/img/PDF@2x.png";
import word from "@/assets/img/word@2x.png";

@Component({})
export default class Attachment extends Vue {
  @Prop({ default: "", type: String })
  fileName: string;
  @Prop({ default: "", type: String })
  fileUrl: string;

  typeIconMap = {
    mp4: MP4,
    xls: Excel,
    xlsx: Excel,
    pdf: pdf,
    doc: word,
    docx: word
  };
  get iconUrl() {
    const suffix = getFileUrlSuffix(this.fileName);
    return this.typeIconMap[suffix || "doc"];
  }
}
